import React, { useMemo } from 'react'
import {
  IcoMoon,
  VehicleNotFitIcon,
  VehicleUniversalFitIcon,
  VehicleFitIcon,
  VehicleRequireInfoIcon,
  PowersportFitIcon,
  PowersportNotFitIcon,
  PowersportUniversalFitIcon,
} from '@usap/uicomponents'
import {
  StyledFitmentLabel,
  StyledFitmentWrapper,
  StyledIconContainer,
  StyledDoesNotFit,
  StyledUniversalFit,
  StyledGuaranteedFit,
  StyledFitmentVehicle,
} from './VehicleFitmentCheckoutWmo.css'
import { GTM } from '@usap/carparts/src/shared/helpers' 

const VehicleFitmentCheckoutWmo = ({
  vehicleLabel,
  vehicleDetails,
  isUniversal,
  isGuaranteed,
  isNoVehicle,
  isNoFit,
  isPowersport,
  isRecommendation,
}) => {
  const { fitWarning } = GTM

  const getFitmentDetails = (label, vehicleLabel, StyledComponent) => (
    <StyledFitmentLabel isRecommendation={isRecommendation}>
      {StyledComponent ? (
        <>
          <StyledComponent>
            {label}
          </StyledComponent>
          <StyledFitmentVehicle isRecommendation={isRecommendation}>
            {vehicleLabel}
          </StyledFitmentVehicle>
        </>
      ) : label}
    </StyledFitmentLabel>
  )
  const doesNotFitDetails = getFitmentDetails('Does Not Fit', vehicleLabel, StyledDoesNotFit)
  const universalFitDetails = getFitmentDetails('Universal Fit', vehicleLabel, StyledUniversalFit)
  const guaranteedFitDetails = getFitmentDetails('Guaranteed to Fit', vehicleLabel, StyledGuaranteedFit)
  const noVehicleDetails = getFitmentDetails('No Vehicle Information Provided. Fitment Not Guaranteed.', null, null)

  const icon = useMemo(() => {
    if (isNoVehicle) {
      return VehicleRequireInfoIcon
    }
    if (isGuaranteed) {
      if (isPowersport) {
        return PowersportFitIcon
      }
      return VehicleFitIcon
    }
    if (isNoFit) {
      if (isPowersport) {
        return PowersportNotFitIcon
      }
      return VehicleNotFitIcon
    }
    if (isPowersport) {
      return PowersportUniversalFitIcon
    }
    return VehicleUniversalFitIcon
  }, [isGuaranteed, isNoFit, isNoVehicle, isPowersport])

  const fitmentLabel = useMemo(() => {
    if (isNoVehicle) {
      return noVehicleDetails
    }
    if (isGuaranteed) {
      return guaranteedFitDetails
    }
    if (isNoFit) {
      fitWarning('Does Not Fit', vehicleDetails)
      return doesNotFitDetails
    }
    return universalFitDetails
  }, [isGuaranteed, isNoFit, isNoVehicle, vehicleLabel])

  const bgColor = useMemo(() => {
    if (isNoVehicle) {
      return '#FFFAE6'
    }
    if (isGuaranteed) {
      return '#F4F8F2'
    }
    if (isNoFit) {
      return '#FDEAE9'
    }
    return '#FFFFFF'
  }, [isGuaranteed, isNoFit, isNoVehicle])

  const borderColor = useMemo(() => {
    if (isNoVehicle) {
      return '#FFCD05'
    }
    if (isGuaranteed) {
      return '#527A36'
    }
    if (isNoFit) {
      return '#CC3333'
    }
    return '#3E3E47'
  }, [isGuaranteed, isNoFit, isNoVehicle])

  const dataTestId = useMemo(() => {
    if (isUniversal) {
      if (vehicleLabel) {
        return 'universal-fitment-with-vehicle'
      }
      return 'universal-fitment-without-vehicle'
    }

    if (isNoVehicle) {
      return 'no-vehicle'
    }
    if (isGuaranteed) {
      return 'guaranteed-fit'
    }
    if (isNoFit) {
      return 'does-not-fit'
    }

    return 'universal-fit'
  }, [isGuaranteed, isNoFit, isNoVehicle, isUniversal, vehicleLabel])

  return (
    <StyledFitmentWrapper bgColor={bgColor} borderColor={borderColor} data-testid={dataTestId}>
      <StyledIconContainer>
        <IcoMoon icon={icon} />
      </StyledIconContainer>
      {fitmentLabel}
    </StyledFitmentWrapper>
  )
}

export default VehicleFitmentCheckoutWmo
